import ServiceHeader from '../../ServiceComponents/ServiceHeader';
export default function CartBannerSection() {
    return (
        <>
            <ServiceHeader
                childClass="cartBanner"
                breadcrumb={<> Cart</>}
                title="Cart"
            />
        </>
    );
}